import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import axiosCancel from 'axios-cancel';
import { appConfig } from 'config';
import { get } from 'lodash';
import ServicesNames from 'app-constants/service.names';

axiosCancel(axios, {
  debug: false, // default
});

class Http {
  client: AxiosInstance;

  constructor() {
    this.client = axios.create({
      baseURL: appConfig.backend_url,
      // baseURL: 'https://api.tofu.vn',
      headers: {
        Accept: 'application/json',
        'accept-language': localStorage.getItem('language') || 'vi',
      },
    });
  }

  configureRequest = ({ accessToken }) => {
    this.client.interceptors.request.use(
      (config: AxiosRequestConfig) => {
        if (!config.headers || !config.headers.authorization) {
          config.headers = {
            authorization: 'Bearer '.concat(accessToken),
          };
        }
        return config;
      },
      (error) => Promise.reject(error)
    );
  };

  configureResponse = ({ doDisplayErrors, doLogout, isAuthenticated }) => {
    this.client.interceptors.response.use(
      async (response: AxiosResponse) => {
        return response;
      },
      (error) => {
        const message = get(
          error,
          'response.data.message',
          get(error, 'response.data.error', error.message)
        );
        const code = get(
          error,
          'response.data.status',
          get(error, 'response.data.statusCode', error.code)
        );
        const url = get(error, 'config.url', error.url);
        if ([401].includes(code) && ![ServicesNames.AUTH_LOGIN].includes(url)) {
          doLogout();
          localStorage.clear();
          const t = setTimeout(() => {
            window.location.reload();
          }, 2000);
          clearTimeout(t);
        } else {
          doDisplayErrors({
            code,
            message: message,
          });
        }
        return Promise.reject(error);
      }
    );
  };
}

export default new Http();
